import _ from 'lodash';
// @mui
import { Stack } from '@mui/system';
import { Box, Button } from '@mui/material';
//components
import FormCreator from 'components/FormCreator';
import { fieldType, validationTypes, invalidFields, fieldsGroupType } from 'components/FormCreator/types';
import { validateFields } from 'components/FormCreator/validation';
import { FormButton } from 'theme/elements/Buttons';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getNewBeneficiary, setMessage, getMessage, isLoading } from 'state/reducers/beneficiary.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getCountries, getCurrencies, getCurrenciesObj } from 'state/reducers/global.reducers';
//sections
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
//constants
import { Beneficiary, BeneficiaryDetailsBankAccount, BeneficiaryStatus } from 'constants/beneficiary.constants';
import { userMessage } from 'constants/ui.constants';
import { fieldsValidations } from './constants';
//services
import { getPaymentsOptions } from 'services/beneficiary.services';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function BankAccountDetailsForm(props: {
	handleChange: any;
	invalidFields: invalidFields;
	setInvalidFields: any;
	isCountryDisabled: boolean;
}) {
	const t = useAppSelector(selectTranslations);
	const beneficiary: Beneficiary = useAppSelector(getNewBeneficiary);
	const prefixFields = 'page.beneficiary.create.step.2.';
	const Countries = useAppSelector(getCountries);
	const userMessage: userMessage = useAppSelector(getMessage);
	const Currencies = useAppSelector(getCurrenciesObj);
	const loading = useAppSelector(isLoading);
	const location = useLocation();
	const paths = location.pathname.split('/');
	const lastPath = paths[paths.length - 1];
	const dispatch = useAppDispatch();

	function getPayments() {
		dispatch(setMessage({ ...userMessage, exist: false }));
		//check fields
		let obj: { [key in keyof Beneficiary]?: string } = {};

		BeneficiaryDetailsBankAccount.forEach((element) => {
			obj[element] = String(beneficiary[element] || '');
		});

		const invalidFields = validateFields(fieldsValidations, obj);
		if (!_.keys(invalidFields).length) {
			dispatch(getPaymentsOptions(beneficiary, true));
		} else {
			props.setInvalidFields(invalidFields);
		}
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		props.handleChange(event);
		if (_.isEqual(name, 'bankAccountCountryId')) {
			if (!_.isNil(value) && !_.isNil(beneficiary.currencyId)) {
				dispatch(getPaymentsOptions({ ...beneficiary, [name]: value }, true));
			}
		}
		if (_.isEqual(name, 'currencyId')) {
			if (!_.isNil(value) && !_.isNil(beneficiary.bankAccountCountryId)) {
				dispatch(getPaymentsOptions({ ...beneficiary, [name]: value }, true));
			}
		}
	};

	return (
		<Box component="form" noValidate>
			<FormCard>
				<FormHeader1
					title={t(`${prefixFields}beneficiary_bank_details.title`)}
					text={t(`${prefixFields}beneficiary_bank_details.text`)}
				/>
				<Stack spacing={2}>
					<FormCreator
						initialValidation={props.invalidFields}
						name="priorityPayment"
						handleChange={handleChange}
						fieldsGroups={[
							{
								type: fieldsGroupType.col,
								fields: [
									{
										type: fieldType.text,
										validation: [validationTypes.requierd],
										props: {
											required: true,
											name: 'bankAccountHolderName',
											label: t(
												`${prefixFields}beneficiary_bank_details.bank_account_holder_name.text`
											),
											placeholder: t(
												`${prefixFields}beneficiary_bank_details.bank_account_holder_name.placeholder`
											),
											value: beneficiary?.bankAccountHolderName || '',
										},
									},
									{
										type: fieldType.select,
										validation: [validationTypes.requierd],
										valueProperty: 'id',
										labelProperty: 'name',
										props: {
											required: true,
											options: _.values(Countries),
											name: 'bankAccountCountryId',
											label: t(
												`${prefixFields}beneficiary_bank_details.bank_account_country.text`
											),
											value: beneficiary?.bankAccountCountryId || '',
											disabled: props.isCountryDisabled,
										},
									},
									...(beneficiary?.bankAccountCountryId &&
									beneficiary.countryId !== beneficiary?.bankAccountCountryId
										? [
												{
													type: fieldType.textArea,
													validation: [validationTypes.min3Chars],
													props: {
														required: true,
														name: 'commentForUnequalCountries',
														label: t(
															`${prefixFields}beneficiary_details.country_difference_reason.text`
														),
														value: beneficiary?.commentForUnequalCountries || '',
														disabled: false,
														maxLength: 200,
														minLength: 4,
													},
												},
										  ]
										: []),
									{
										type:
											!_.isEqual(lastPath, 'new') &&
											!_.isEqual(beneficiary.status, BeneficiaryStatus.PendingBankAccountDetails)
												? fieldType.text
												: fieldType.select,
										validation: [validationTypes.requierd],
										valueProperty: 'id',
										labelProperty: 'name',
										props: {
											required: true,
											disabled:
												!_.isEqual(lastPath, 'new') &&
												!_.isEqual(
													beneficiary.status,
													BeneficiaryStatus.PendingBankAccountDetails
												),
											name: 'currencyId',
											options: _.values(Currencies),
											label: t(`${prefixFields}beneficiary_bank_details.currency.text`),
											value:
												!_.isEqual(lastPath, 'new') &&
												!_.isEqual(
													beneficiary.status,
													BeneficiaryStatus.PendingBankAccountDetails
												)
													? _.get(Currencies, beneficiary?.currencyId || '')?.name
													: beneficiary?.currencyId || '',
										},
									},
								],
							},
						]}
					/>
					{/* <FormButton alignContent='right'>                
                <Button variant='contained' disabled={loading} onClick={getPayments}>{t('portal.actions.create_payment')}</Button>
            </FormButton> */}
				</Stack>
			</FormCard>
		</Box>
	);
}
